import { LANGUAGE_CODE } from '@healthhub/react-ui';
import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import { MY_CHILDREN_PROFILE_DETAILS_PATH } from '@shared/constants/paths';
import type { RouteConfig } from '@shared/types/common.types';

const PortalChildrenHealthProfilePage = lazy(
  () => import('@features/HealthProfile/ChildrenHealthProfile/pages/PortalChildrenHealthProfilePage')
);

export const CHILDREN_HEALTH_PROFILE_ROUTES: RouteConfig[] = [
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL],
    component: () => <PortalChildrenHealthProfilePage />,
    displayTitle: () => '',
    layoutProps: {
      contentClassName: 'lg:max-w-none',
      noStyleContent: true,
    },
    pageType: PageType.PRIVATE,
    path: MY_CHILDREN_PROFILE_DETAILS_PATH,
    serviceCatalogCode: '',
    titleTransKey: 'leftNavText.childDetails',
    translationFile: 'translation',
  },
];
